import PropTypes from 'prop-types';

function formatDaysOnMarket(daysOnMarket) {
  if (daysOnMarket) {
    let domUnit;

    switch (daysOnMarket) {
      case null:
        domUnit = '';
        break;
      case 1:
        domUnit = ' day';
        break;
      default:
        domUnit = ' days';
    }

    return String(daysOnMarket) + domUnit;
  }
  return '-';
}

DaysOnMarket.propTypes = {
  daysOnMarket: PropTypes.number,
};

export default function DaysOnMarket({daysOnMarket}) {
    return (
      <span>{
        formatDaysOnMarket(daysOnMarket)
      }</span>
    );
}